import styled from "styled-components";

export const LogoItem = styled.img`
height: 80px;
width: auto;

@media screen and (max-width: 768px) {
    height: 60px;
}
`